export function vibrate(length) {
  return function decorator(target, key, descriptor) {
    const origFn = descriptor.value;
    // eslint-disable-next-line no-param-reassign
    descriptor.value = async function decorated(...args) {
      if ('vibrate' in navigator) {
        navigator.vibrate(length);
      }
      await origFn.call(this, ...args);
    };
    return descriptor;
  };
}
